import React from "react";

function Music() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      fill="none"
      viewBox="0 0 40 40"
    >
      <path
        d="M15 32.5C15 35.2614 12.2018 37.5 8.75 37.5C5.29822 37.5 2.5 35.2614 2.5 32.5C2.5 29.7386 5.29822 27.5 8.75 27.5C12.2018 27.5 15 29.7386 15 32.5Z"
        fill="currentColor"
      />
      <path
        d="M37.5 27.5C37.5 30.2614 34.7018 32.5 31.25 32.5C27.7982 32.5 25 30.2614 25 27.5C25 24.7386 27.7982 22.5 31.25 22.5C34.7018 22.5 37.5 24.7386 37.5 27.5Z"
        fill="currentColor"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35 27.5V4.99998H37.5V27.5H35ZM15 7.49998V32.5H12.5V7.49998H15Z"
        fill="currentColor"
      />
      <path
        d="M12.5 7.26245C12.5 5.97807 13.4732 4.90266 14.7512 4.77486L34.7512 2.77486C36.2229 2.62769 37.5 3.7834 37.5 5.26245V7.49998L12.5 9.99998V7.26245Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Music;
